module.exports = __webpack_public_path__ + "img/blog-01.15966efa.jpg";